<template>

  <div class="seckill">
    <div class="left">
      <div class="title">{{$t('骏芯秒杀')}}</div>
      <div class="img"> <i class="iconfont icon-shandian"></i> </div>
      <div class="time">
        <div class="tips"><span>{{data.changci}}</span>{{$t('点场')}} {{ac?'距开始':'距结束'}}</div>
        <div class="timer">
          <span class="h">{{h}}</span>:
          <span class="m">{{m}}</span>:
          <span class="s">{{s}}</span>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="btn">
        <span class="lefts"
              @click="changeLeft()"><i class="iconfont icon-arrow-left"></i></span>
        <span class="rights"
              @click="changeRight()"><i class="iconfont icon-arrow-right"></i></span>
      </div>
      <div class="list"
           :style="{left:left+'px',width:(data.goods&&data.goods.length>0?data.goods.length*200:0)+'px'}">
        <div class="item"
             v-for="(item,index) in data.goods"
             :key="index"
             @click="getId(item)">
          <div class="img"><img :src="$jx.oss(item.image)"
                 alt=""></div>
          <span class="name ellipsis">{{item.title}}</span>
          <span>¥{{item.price}}</span>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="title">
        <div class="new">{{$t('最新帖子')}} </div>
        <div class="right"
             @click="goPage">
          <span>{{$t('更多')}}</span>
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </div>
      <div class="content">
        <img src="/static/img/Snipaste_2022-06-25_09-16-18.png"
             alt="">
        <div class="list">
          <div class="item pointer"
               v-for="(item,index) in newthree"
               :key="index"
               @click="goPage(item.id,true)">
            <span :class="index == 0 ? 'hot' : 'n'">{{'最新'}}</span>
            <div class="ellipsis c">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      data: {},
      h: '',
      m: '',
      s: '',
      timer: null,
      left: 0,
      newthree: [],
      ac: false
    }
  },
  created () {
    this.getnewchangci()
  },
  methods: {
    getId (data) {
      this.$router.push({ name: 'seckill' })
      // data = JSON.stringify({ id: data.id, miao: true })
      // this.$router.push({
      //   path: `/main/goods/${data}`,
      // })
    },
    goPage (id, isPage) {
      let common = JSON.parse(localStorage.getItem('jx:common')).data
      if (isPage) {
        window.open(common.web_forum + `/question/${id}`)
      } else {
        window.open(common.web_forum)
      }
    },
    changeLeft () {
      if (this.data.goods.length > 4 && (this.data.goods.length * 200 - Math.abs(this.left) > 800)) {
        this.left -= 200
      }
    },
    changeRight () {
      if (this.left < 0) {
        this.left += 200
      }
    },

    second (value) {
      var theTime = parseInt(value); // 秒  
      var theTime1 = 0; // 分  
      var theTime2 = 0; // 小时  
      if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (theTime1 > 60) {
          theTime2 = parseInt(theTime1 / 60);
          theTime1 = parseInt(theTime1 % 60);
        }
      }
      var result = "" + parseInt(theTime) + "秒";
      if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + "分" + result;
      }
      if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + "小时" + result;
      }
      this.h = theTime2 < 10 ? '0' + theTime2 : theTime2
      this.m = theTime1 < 10 ? '0' + theTime1 : theTime1
      this.s = theTime < 10 ? '0' + theTime : theTime
    },
    getnewchangci () {
      this.$http.get("/wanlshop/Activity/getnewchangci", {}).then(res => {
        this.data = res.data;
        let orTime = parseInt(new Date().getTime() / 1000);
        let starttime = res.data.activity.starttime
        let endtime = res.data.activity.endtime
        let s = endtime - orTime;
        let t = starttime - orTime
        if (t > 0 && res.data.id == 1) {
          this.ac = true
          this.second(t)
          if (t > 0) {
            this.timer = setInterval(() => {
              t -= 1;
              this.second(t)
              if (t == 0) {
                this.ac = false
                clearInterval(this.timer)
              }
            }, 1000);
          }
        } else {
          this.ac = false
          this.second(s)
          if (s > 0) {
            this.timer = setInterval(() => {
              s -= 1;
              this.second(s)
              if (s == 0) {
                clearInterval(this.timer)
              }
            }, 1000);
          }
        }
      },
        err => {

        })
      this.$http.get("/wanlshop/news/getask", {}).then(res => {
        this.newthree = res.data
      },
        err => {
        })
    }
  }
}

</script>
<style lang="scss">
.seckill {
  display: flex;
  justify-content: space-between;
  height: 283px;
  margin-top: 30px;

  .left {
    width: 190px;
    height: 100%;
    background-color: #0094e7;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: space-between;

    .title {
      font-size: 32px;
      color: #ffffff;
      font-weight: bold;
      margin: 35px 0 40px 0;
    }

    .img {
      i {
        font-size: 40px;
        color: #ffffff;
      }
    }

    .time {
      font-size: 16px;
      color: #ffffff;
      margin-top: 30px;

      .tips {
        span {
          font-weight: bold;
          font-size: 20px;
        }
      }

      .timer {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        span {
          background-color: #ff971d;
          color: #ffffff;
          font-size: 22px;
          padding: 0 4px;
        }
      }
    }
  }

  .center {
    flex: 1;
    background-color: #fff;
    width: 800px;
    overflow: hidden;
    position: relative;

    .btn {
      position: absolute;
      width: 820px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;

      .lefts,
      .rights {
        cursor: pointer;
        width: 22px;
        height: 30px;
        background-color: #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          color: #fff;
          font-size: 18px;
        }
      }

      .lefts {
        z-index: 1;
        border-radius: 0 50px 50px 0;

        i {
          margin-right: 2px;
        }
      }

      .rights {
        z-index: 1;
        border-radius: 50px 0 0 50px;

        i {
          margin-left: 2px;
        }
      }
    }

    .list {
      /* display: flex; */
      /* justify-content: flex-start; */
      height: 100%;
      position: relative;
      /* width: 20000px; */
      transition: left 0.5s;

      .item {
        float: left;
        width: 200px;
        height: 100%;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        box-sizing: border-box;
        cursor: pointer;

        .img {
          width: 100%;
          height: 180px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        img {
          width: 150px;
          height: 150px;
        }

        &::after {
          position: absolute;
          content: "";
          width: 1px;
          height: 150px;
          background-color: #f2f2f2;
          right: 0;
          display: inline-block;
          top: 50px;
        }

        &:last-child {
          &::after {
            width: 0;
          }
        }

        span {
          color: #e1251b;
          font-size: 16px;
          font-weight: bold;
        }

        .name {
          font-size: 14px;
          color: #333333;
          font-weight: normal;
          margin: 10px 0;
          width: 150px;
          text-align: center;
          box-sizing: border-box;
        }
      }
    }
  }

  > .right {
    width: 190px;
    background-color: #ffffff;
    box-sizing: border-box;
    padding: 10px 15px;
    border-left: 1px solid #f4f6fa;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .new {
        color: #000000;
        font-size: 14px;
        font-weight: bold;
      }

      .right {
        color: #999;
        font-size: 12px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
      }
    }

    .content {
      img {
        width: 100%;
      }

      .list {
        font-size: 14px;
        margin-top: 10px;

        .item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 5px 0;

          span {
            padding: 0 4px;
            white-space: nowrap;
          }

          .n {
            background-color: #e3f5ff;
            color: #42a3ea;
          }

          .hot {
            background-color: #feebe9;
            color: #ea2a35;
          }

          .c {
            margin-left: 10px;
            color: #333333;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/seckill/seckill.vue